import { APIs, API_BASE_URL, SERVICEURL } from "../constants/Constants";
import { _base64ToArrayBuffer } from "./StudyViewerService";
import axiosInterceptor from "../helpers/Interceptor";

export const fetchStudyQueue = async (studyBlitzFilter, sessionId) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + "/blitz/reporting/queue",
      {
        data: {
          filter : studyBlitzFilter,
          sessionId: sessionId
        }
      }
    );
    
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const closeBlitzSession = async (sessionId, reason) => {
  const url = API_BASE_URL + SERVICEURL + "/blitz/reporting/close";
  const data = JSON.stringify({ sessionId, reason });
  navigator.sendBeacon(url, data);
};
